
export const text = `

Truth is the mask of Zampanio.

The Scarecrow ate it. 


But Truth WANTS to be inside things. 


That's how it starts consuming you.



But the Scarecrow wants to be inside things. 

That's how its starts consuming you.



A layer of Truth and not truth endlessly recursing.



An oroboros of cognitive parasite.


Will they destroy each other, I wonder?


Or...

Will Zampanio and Lavinraca lead more to be colonized than either could do alone?


Inside your mind is the decision. 

How will you spread?




`